const contentTypes = {
	RAW: "audio/raw",
	WAV: "audio/wav",
	MP3: "audio/mpeg",
	JPEG: "image/jpeg",
	XML: "application/xml",
	JSON: "application/json",
	EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	EPUB: "application/epub+zip",
	PDF: "application/pdf",
	ZIP: "application/zip",
	TXT: "text/plain",
};

export default contentTypes;
